export default __webpack_public_path__ + "static/media/course-preview-default-img.d4154b69.svg";